import React, { useState, useEffect, useContext } from 'react';

import { LayoutContext } from '../../context/layoutContext';
import { Body } from '../../styles/homeStyles';
import Skeleton from '../../components/skeleton/Skeleton';

import { connect } from 'react-redux';

const PromotionBanner = ({ Pn, Pt, Pb, category, bannerData }) => {
  const { matchese } = useContext(LayoutContext);

  const [banner, setBanner] = useState('');

  useEffect(() => {
    if (bannerData.length) {
      const data = bannerData.filter(i => i.category === category)[0];
      if (data?.img instanceof Array) data.img = data.img[0];
      setBanner(data);
    }
  }, [bannerData]);

  const goURl = d => {
    if (d?.linkType === 'url' && d?.link) {
      window.open(d?.link, '_blank');
    }
  };

  return (
    <Body Pn={Pn} Pt={Pt} Pb={Pb}>
      {banner ? (
        <div style={{ margin: '10px 1%', cursor: banner?.link ? 'pointer' : '' }} onClick={() => goURl(banner)}>
          <img
            alt='promotionBanner'
            src={matchese ? (banner?.mobileImg?.url ? banner?.mobileImg?.url : banner?.img?.url) : banner?.img?.url}
            style={{ width: '100%', height: '142px', objectFit: matchese ? 'fill' : 'cover' }}
          />
        </div>
      ) : (
        <Skeleton width={'100%'} height={'142px'} margin={'10px 1%'} />
      )}
    </Body>
  );
};

const mapStateToProps = state => {
  return {
    bannerData: state.bannerData.banner,
  };
};

export default connect(mapStateToProps)(PromotionBanner);
